import React from 'react'

const SalesChannelMetrics = () => {
    return (
        <>
            SalesChannelMetrics
        </>

    )
}

export default SalesChannelMetrics